/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const ApiKeyCreateRequest = zod
	.object({
		name: zod.string().describe('API key name')
	})
	.describe('Request body for creating an API key');

export type ApiKeyCreateRequest = zod.input<typeof ApiKeyCreateRequest>;
export type ApiKeyCreateRequestOutput = zod.output<typeof ApiKeyCreateRequest>;
